'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _greekLetters = require('../tokens/greek-letters');

var greekLetters = _interopRequireWildcard(_greekLetters);

var _logger = require('../logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Will format a parsed latex object, to a calculatable string
 * @param  {object} parsedLatex An object parsed by "./parser.js"
 * @return {string} A calculatable string, eg. "(1+3)/4*sqrt(2)"
 */
var formatter = function formatter(parsedLatex) {
  var formattedString = '';

  formattedString += '(';

  for (var i = 0; i < parsedLatex.length; i++) {
    var item = parsedLatex[i];

    if (item.type === 'number') {
      if (i > 0) {
        if (parsedLatex[i - 1].type !== 'number' && parsedLatex[i - 1].type !== 'operator') {
          _logger2.default.debug('Adding * before number: ' + item.value + ', previous item: ' + parsedLatex[i - 1].type);
          formattedString += '*';
        }
      }
      formattedString += item.value;
    }

    if (item.type === 'operator') {
      if (i === 0 && (item.value === '+' || item.value === '*')) {
        _logger2.default.debug('Structure starting with * or +, ignoring');
      } else formattedString += item.value;
    }

    if (item.type === 'variable') {
      if (i > 0) {
        if (parsedLatex[i - 1].type !== 'operator') {
          _logger2.default.debug('Adding * before variable: ' + item.value + ', previous item: ' + parsedLatex[i - 1].type);
          formattedString += '*';
        }
      }
      formattedString += item.value;
    }

    if (item.type === 'group') {
      formattedString += formatter(item.value);
    }

    if (item.type === 'token') {
      _logger2.default.debug('Handling token: ' + item.value);

      if (greekLetters.getSymbol(item.value) !== null) {
        var letter = greekLetters.getSymbol(item.value);
        _logger2.default.debug('greek letter ' + letter);
        formattedString += letter;
      }

      if (item.value === 'frac') {
        if (parsedLatex[i + 1].type === 'group' && parsedLatex[i + 2].type === 'group') {
          _logger2.default.debug('Found fraction');
          formattedString += formatter(parsedLatex[i + 1].value) + '/' + formatter(parsedLatex[i + 2].value);
          i += 2;
        } else {
          return new Error('Fraction must have 2 following parameters');
        }
      }

      if (item.value === 'cdot' || item.value === 'times' || item.value === 'ast') {
        formattedString += '*';
      }

      if (item.value === 'div') {
        formattedString += '/';
      }
    }

    if (item.type === 'function') {
      formattedString += item.value;

      var nextItem = parsedLatex[i + 1];

      if (item.value === 'sqrt') {
        if (parsedLatex[i + 1].type === 'group') {
          _logger2.default.debug('Found square root');
          formattedString += formatter(parsedLatex[i + 1].value);
          i++;
        } else {
          return new Error('Square root must be followed by {}');
        }
      } else if (nextItem.type === 'number' || nextItem.type === 'variable') {
        formattedString += '(';
        formattedString += nextItem.value;
        formattedString += ')';
        i++;
      }
    }
  }

  formattedString += ')';

  return formattedString;
};

exports.default = formatter;


// WEBPACK FOOTER //
// ./~/algebra-latex/lib/formatters/format-math.js